module.exports = __webpack_public_path__ + "static/media/promotion-banner-mobile.c9945158.png";